// extracted by mini-css-extract-plugin
export default {"sendButton":"SendButton_sendButton__qQ-bv"};